module.exports = __webpack_public_path__ + "media/images/comment_staff-93588dd9.png";